import React from 'react';

const Help = props => (
    <svg xmlns="http://www.w3.org/2000/svg" width={props.width || '7'} height={props.height || '8'} viewBox="0 0 7 8" style={{ pointerEvents: 'none' }}>
        <g fill="none" fillRule="evenodd">
            <g fill="#F63A3A" fillRule="nonzero">
                <path d="M183.323 14.159c0-1.166 1.848-1.364 1.848-3.124 0-1.298-1.144-2.035-2.794-2.035-1.485 0-2.519.572-3.113 1.474l1.331.781c.352-.506.891-.814 1.595-.814.715 0 1.188.341 1.188.88 0 .957-1.716 1.298-1.716 2.838h1.661zm-.825 2.761c.616 0 1.056-.451 1.056-1.001 0-.561-.44-.979-1.056-.979-.616 0-1.056.418-1.056.979 0 .55.44 1.001 1.056 1.001z" transform="translate(-1362 -495) translate(1183 486)" />
            </g>
        </g>
    </svg>
);

export default Help;
